import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { OnayKutusu } from "@koclukpanel/ui";
import { bildirimTercihi, bildirimTercihlerim } from "./api";

/**
 * AKŞAM HATIRLATMASI AYARI — F-NTF-12 (Emre 05.10.2026)
 *
 * "Öğrenci kendi ayarından kapatabilir." 18 yaş altı DAHİL herkes için
 * varsayılan AÇIK; kapatınca hem panel içi hem e-posta hatırlatması
 * durur (iki tercih birlikte yazılıyor — yalnız e-postayı kapatmak,
 * öğrencinin "kapattım" dediği bildirimi panelde görmeye devam etmesi
 * demekti).
 *
 * Kayıt YOKSA açık sayılıyor (sunucunun varsayılanı ile aynı).
 */
const OLAY = "VeriGirisiEksik";
const KANALLAR = ["IN_APP", "EMAIL"] as const;

export function AksamHatirlatmaAyari() {
  const qc = useQueryClient();
  const tercihler = useQuery({ queryKey: ["bildirim-tercihlerim"], queryFn: bildirimTercihlerim });
  const kayit = tercihler.data?.find((t) => t.eventCode === OLAY && t.channel === "IN_APP");
  const acik = kayit ? kayit.enabled : true;

  const kaydet = useMutation({
    mutationFn: async (yeni: boolean) => {
      for (const k of KANALLAR) await bildirimTercihi(OLAY, k, yeni);
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["bildirim-tercihlerim"] }),
  });

  return (
    <div className="px-4 pt-3">
      <OnayKutusu
        etiket="Akşam hatırlatması (20:00)"
        yardim="O gün sonucunu girmediğin görev varsa akşam hatırlatırız. İstersen kapatabilirsin."
        checked={acik}
        disabled={tercihler.isLoading || kaydet.isPending}
        onChange={(e) => kaydet.mutate(e.target.checked)}
      />
      {kaydet.isError && (
        <p role="alert" className="text-hata-700 mt-1 text-xs">
          Ayar kaydedilemedi, tekrar dener misin?
        </p>
      )}
    </div>
  );
}
